export const SALON_USERNAME = 'beautysalon'